import "../css/card.css";

function Card(props) {
  return (
    <>
      <div className="card">
        <img src={props.src} alt={props.alt}></img>

        <div className="container">{props.content}</div>
      </div>
    </>
  );
}

export default Card;
